import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["name"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", {
        name: _ctx.formName,
        onSubmit: _cache[0] || (_cache[0] = ($event) => (_ctx.submitForm($event)))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 40, _hoisted_1));
}
